import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nText, EmphasisTag } from '@welldev-group/react-comp-lib';
import { Menu, MenuItem } from '@welldev-group/rcl-menu';
import Icon from '@welldev-group/rcl-icon';
import IconButton from '@welldev-group/rcl-icon-button';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

import CreditCardIcon from './CreditCardIcon';

const PrimaryShapeStringAndNumber = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

const CreditCard = props => {
  const {
    id,
    asSelected,
    lastFour,
    cardType,
    cardholderName,
    disableAction,
    affiliateId,
    fetchCreditCards,
    primary,
    clickable,
  } = props;

  const [isVisible, setIsVisible] = useState(false);
  const onOutsideClick = () => {
    setIsVisible(false);
  };

  const makePrimary = async () => {
    await httpClient.patch(
      routes.billing.credit_cards.update({
        affiliate_id: affiliateId,
        id,
      }),
      {
        primary: true,
      },
    );
  };

  const executeMakePrimary = () => {
    makePrimary().then(() => {
      fetchCreditCards();
    });
  };

  return (
    <div
      className={classNames('billing__credit-card-container', {
        'billing__credit-card-container--as-selected': asSelected,
        'billing__credit-card-container--clickable': clickable,
      })}
    >
      <div className="col-grid col-bleed direction-row align-center justify-space-between">
        <div className="billing__credit-card-container-icon">
          <CreditCardIcon cardType={cardType} />
        </div>
        <div className="col-grid col-bleed billing__credit-card-container-info">
          <span className="billing__credit-card-container-number">
            {`**** **** **** ${lastFour}`}
          </span>
          <span className="billing__credit-card-container-name">{cardholderName}</span>
        </div>
        <div className="billing__credit-card-container-actions">
          {primary && (
            <EmphasisTag
              text={<I18nText id="billing.payment_details.primary" />}
              size="tiny"
              type="important"
            />
          )}
          {!disableAction && (
            <Menu
              className="billing__credit-card-container-make-primary"
              isVisible={isVisible}
              size="small"
              popOverDirection="bottom-right"
              onOutsideClick={onOutsideClick}
              label={
                <IconButton
                  size="small"
                  color="default"
                  onClick={() => {
                    setIsVisible(previousIsVisibleState => !previousIsVisibleState);
                  }}
                  icon={<Icon name="horizontalDots" />}
                />
              }
            >
              <MenuItem onClick={executeMakePrimary}>
                <I18nText id="billing.payment_details.make_primary" />
              </MenuItem>
            </Menu>
          )}
        </div>
      </div>
    </div>
  );
};

CreditCard.defaultProps = {
  asSelected: false,
  primary: false,
  clickable: false,
  fetchCreditCards: () => {},
};

CreditCard.propTypes = {
  asSelected: PropTypes.bool,
  id: PrimaryShapeStringAndNumber.isRequired,
  lastFour: PropTypes.string.isRequired,
  cardType: PropTypes.string.isRequired,
  cardholderName: PropTypes.string.isRequired,
  disableAction: PropTypes.bool.isRequired,
  affiliateId: PrimaryShapeStringAndNumber.isRequired,
  fetchCreditCards: PropTypes.func,
  primary: PropTypes.bool,
  clickable: PropTypes.bool,
};

export default CreditCard;
